import { useContext } from 'react';
import { AppContext } from '~/App';

// TODO rename to useStorage now that this supports session as well?
export function useLocalStorage(options?: { session?: boolean }) {
  const { tenant } = useContext(AppContext);
  const tenantId = tenant?.id;

  function get(key: string) {
    const storage = options?.session
      ? window.sessionStorage
      : window.localStorage;

    // If no tenant ID, fall back to a global key (for unauthenticated state)
    const storageKey = tenantId ? `tid:${tenantId}::${key}` : `global::${key}`;
    return storage.getItem(storageKey);
  }

  function set(key: string, value: string) {
    const storage = options?.session
      ? window.sessionStorage
      : window.localStorage;

    // If no tenant ID, fall back to a global key (for unauthenticated state)
    const storageKey = tenantId ? `tid:${tenantId}::${key}` : `global::${key}`;
    return storage.setItem(storageKey, value);
  }

  return { get, set };
}
